import React, {createContext, useContext} from 'react';
import {node, oneOf, string} from 'prop-types';

const AuthContext = createContext('');

export const AUTH_TARGETS = {
  PROD: 'prod',
  STAGING: 'staging',
};

export const useMapAuth = () => useContext(AuthContext);

export const MapAuthProvider = ({
  children,
  mapboxAccessToken,
  authToken,
  authTarget = AUTH_TARGETS.PROD,
}) => (
  <AuthContext.Provider value={{mapboxAccessToken, authToken, authTarget}}>
    {children}
  </AuthContext.Provider>
);

MapAuthProvider.propTypes = {
  children: node,
  mapboxAccessToken: string,
  authToken: string,
  authTarget: oneOf([AUTH_TARGETS.PROD, AUTH_TARGETS.STAGING]),
};
